export class Filter {
    grades: string[];
    classes: string[];
    registration: number;
    activation: number;
    roles: string[];
    routes: string[];
    gates: string[];
    attendance:string[];
    sounds: string[];
    status:string[];
    view:string;
}